import { GetNonVwfsLessorsResponse } from "@/app/api/non-vwfs-lessors/route";
import { getNonVwfsLessorsRequestSchema } from "@/lib/schemas/non-vwfs-lessors";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const NON_VWFS_LESSORS_ENDPOINT = "/api/non-vwfs-lessors";

export const invalidateNonVwfsLessorsQuery = createInvalidateQuery(
  NON_VWFS_LESSORS_ENDPOINT,
);

export const useNonVwfsLessorsQuery =
  createQueryHook<GetNonVwfsLessorsResponse>(
    NON_VWFS_LESSORS_ENDPOINT,
    getNonVwfsLessorsRequestSchema,
  );
